module.exports = __webpack_public_path__ + "img/ref.3a5e395d.svg";